<template>
  <keep-alive>
    <v-container fluid class="d-flex flex-column h-100 pa-0 min-height-inherit">
      <div class="d-flex flex-row h-100 pa-0 min-height-inherit"     v-if="type == 'Admin'">
        <side-menu class="hidden-sm-and-down" />
        <content-section v-if="routername === 'admin-donations'"/>
          <router-view />
      </div>
            <not-found v-else />
      <v-snackbar v-model="snackbar">
        {{ errorMessage }}
      </v-snackbar>
    </v-container>
  </keep-alive>
</template>
<script>
import { mapState } from "vuex";
import ContentSection from "./AdminDonations.vue";
import SideMenu from "../home/AdminHomeSideMenu";
import notFound from "../../NotFound.vue"
export default {
  components: { ContentSection, SideMenu,notFound },
  data() {
    return {
      snackbar: false,
      errorMessage: null
    };
  },
    computed: {
    routername() {
      const routeName = this.$route.name;
      return routeName;
    },
    ...mapState("auth", {
      profile: "profile"
    }),
      type() {
    // Adjust the property name if your profile object uses a different key for user type/role
    return this.profile && this.profile.type ? this.profile.type : null;
  }
  },
  methods: {
    onSelectEvent(event) {
      console.log(event);
    }
  }
};
</script>
<style scoped>
.agency-title {
  color: #472583;
  font-size: 50px;
  font-weight: bold;
}
.title-line {
  height: 2px;
  width: 100%;
  background-color: #472583;
}
.agency-scroll-section {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
}

::-webkit-scrollbar {
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px light-grey;
  border-radius: 4px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #feb934;
  border-radius: 4px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #f5bd4d;
}

.product-title {
  font-size: 28px;
  color: #472583;
  font-weight: 500;
}
.category-title {
  font-size: 32px;
  color: #472583;
  font-weight: 500;
}
.price-text {
  font-size: 18px;
  color: #472583;
  font-weight: 500;
}
.agency-scroll-section {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
}
</style>
